import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslocoModule} from '@ngneat/transloco';
import {ContextHelpComponent} from './context-help.component';

/**
 * Contextual help feature module. Declared separately (like BackdropModule / BsCustomModalModule)
 * and re-exported by SharedModule, so `<app-context-help>` is available everywhere SharedModule is
 * imported without enlarging SharedModule's own declaration list.
 */
@NgModule({
  declarations: [ContextHelpComponent],
  imports: [
    CommonModule,
    TranslocoModule
  ],
  exports: [ContextHelpComponent]
})
export class ContextualHelpModule {
}
